import { render, staticRenderFns } from "./tab2-ktxc.vue?vue&type=template&id=7fd886e6&scoped=true"
import script from "./tab2-ktxc.vue?vue&type=script&lang=js"
export * from "./tab2-ktxc.vue?vue&type=script&lang=js"
import style0 from "./tab2-ktxc.vue?vue&type=style&index=0&id=7fd886e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd886e6",
  null
  
)

export default component.exports